/** PlaneMesh resource slice: claims the type name, re-exports its decode. */
import { registerGenericResourceSlice } from '../../sliceRegistration.js';
registerGenericResourceSlice('planemesh', ['PlaneMesh']);
//# sourceMappingURL=index.js.map